<script>
import SheetTable from "@/components/UIComponents/SheetTable"
import { getSheet } from "@/api/sheet/sheet"
import { getSheetViewData } from "@/api/sheet/sheetView"
import { setFrontSetting, getFrontSetting } from "@/api/user"
import { transFieldControl } from "@/utils/sheet"
import emitter from "@/mixins/emitter"
import BtnMixin from "@/components/UIComponents/BtnMixin"

/**
 * 关联表
 */
export default {
  name: "RefSheetTable",
  extends: SheetTable,
  props: {
    refControl: Object, // 关联表控件
    showSelection: Boolean,
    deleteVisible: {
      type: Boolean,
      default: true
    },
    dataIds: Array, // undefined: 添加关联数据窗口,需要显示所有数据, Array: 关联数据展示
    conditions: Array
  },
  mixins: [BtnMixin, emitter],
  computed: {
    settingId() {
      // 在一些情况下（比如树状结构从已有数据复制时），没有_cid，就用refSheetId代替
      return this.refControl?._cid || this.refControl?.refSheetId
    },
    sheetId() {
      return this.refControl?.refSheetId
    },
    fields() {
      return this.refControl?.fields
    },
    btnColumnVisible() {
      return this.showBtnColumn
    }
  },
  data() {
    return {
      structInitPromise: null,
      from: "RefSheetTable"
    }
  },
  watch: {
    refControl: {
      immediate: true,
      handler(refControl) {
        if (!refControl) return
        this.$nextTick(() => {
          this.treeKey = refControl.treeKey
          this.structInitPromise = this.initSheetStruct(this.sheetId)
          this.refreshData()
        })
      }
    },
    dataIds() {
      this.refreshData()
    },
    conditions: {
      handler(newVal, oldVal) {
        if (this._.isEqual(newVal, oldVal)) return
        this.pageInfo.currentPage = 1
        this.refreshData()
      }
    }
  },
  methods: {
    initAll() {
      // do nothing
      // 让sheetTable的watch不自动刷新数据
    },
    async initSheetStruct(sheetId) {
      if (!sheetId) return
      this.hasTableData = false
      this.tableData = []
      this.pageInfo = { total: 0, currentPage: 1, pageSize: 20 }
      this.hasTableStructure = false
      let [front, sheet] = await Promise.all([getFrontSetting(this.settingId), getSheet(sheetId)])
      this.front = front || {}
      this.sorts = front?.sorts || []
      this.sortItem = this.sorts.length
        ? this.sorts[0]
        : {
            key: "",
            direction: ""
          }
      this.columnWidth = front?.columnWidth || {}
      this.columnLock = front?.columnLock || []
      this.sheetDef = sheet
      this.allFields = sheet.controls
      this.tableFields = this.transFields(sheet.controls)
      this.hasTableStructure = true
    },
    initTableData() {
      if (!this.sheetId) return
      this.hasTableData = false
      this.select = "本页"
      this.checkAll = false
      this.isIndeterminate = false
      let select = {
        tableData: [],
        length: 0,
        command: "本页"
      }
      this.$emit("selection-change", select)
      this.tableFields = this.transFields(this.allFields)
      return getSheetViewData({
        sheetId: this.sheetId,
        dataIds: this.dataIds,
        page: this.pageInfo.currentPage,
        size: this.pageInfo.pageSize,
        conditions: this.conditions,
        sorts: this._.isEmpty(this.sorts)
          ? this._.isEmpty(this.refControl.sorts)
            ? []
            : this.refControl.sorts
          : this.sorts, // 默认排序为ID顺序
        ...this.refCondSearch,
        treeKey: this.dataIds ? null : this.treeKey, // dataIds 和 treeKey 不能同时存在
        refDataShowAsFirstField: true
      })
        .then(async res => {
          await this.structInitPromise
          let tableData = this.dealTableData(res.content)
          tableData.forEach(row => (row.deep = 0))
          this.tableData = tableData
          this.pageInfo.total = res.totalElements
        })
        .finally(() => {
          this.hasTableData = true
          if (this.tableData[0]?.projectName !== undefined) {
            this.tableFields.unshift({
              rawControl: null,
              cid: null,
              label: "项目",
              value: "projectName",
              type: null,
              oneFlag: null,
              dataType: null,
              main: null,
              description: null,
              fixed: "left",
              isRef: true
            })
          }
        })
    },
    btnClick(command, col) {
      switch (command) {
        case "sortAsc":
          this.sortItem = {
            direction: "ASC",
            key: col.cid
          }
          this.sorts = [this.sortItem]
          setFrontSetting(this.sorts, this.settingId, "sorts")
          this.refreshData()
          break
        case "sortDesc":
          this.sortItem = {
            direction: "DESC",
            key: col.cid
          }
          this.sorts = [this.sortItem]
          setFrontSetting(this.sorts, this.settingId, "sorts")
          this.refreshData()
          break
        case "lock":
          col.fixed = "left"
          this.$refs.baseTable.refreshColumn()
          this.columnLock.push(col.cid)
          setFrontSetting(this.columnLock, this.settingId, "columnLock")
          break
        case "unlock":
          col.fixed = null
          this.$refs.baseTable.refreshColumn()
          this.columnLock.splice(this.columnLock.indexOf(col.cid), 1)
          setFrontSetting(this.columnLock, this.settingId, "columnLock")
          break
        case "filter":
          this.$emit("openFilter", col)
          break
      }
    },
    async clickBtn(command, row) {
      this.dataId = row.id
      this.sheetData = row
      switch (command) {
        case "edit":
          this.editDialogType = "edit"
          this.$refs.editDialog.open()
          break
        case "delete":
          await this.deleteSheetData(this.dataId, this.sheetDef.appId)
          this.refreshData(
            Object.assign(this.parentMap[this.sheetData.id] || {}, { hasChildren: true })
          )
          this.emitCountChange()
          break
        case "lock":
        case "unlock":
          await this.lockOrUnlockData(this.sheetData)
          this.refreshData()
          break
        case "print":
          this.$refs.selectPrintTemplateDialog.open({
            dataId: this.dataId,
            sheetId: this.sheetData.sheetId,
            appId: this.sheetDef.appId
          })
          break
        case "copy":
          this.editDialogType = "copy"
          this.handleCopyData(this.dataId, this.sheetDef.appId, this.sheetDef)
          break
        case "sync":
          this.selection.tableData = [row]
          this.$refs.syncDataDialog.open()
          break
        case "project":
          this.$refs.setRelatedProjectDialog.open()
          break
      }
      let btn = row.sheetBtnList.find(x => x.id == command)
      this.activeCustomBtn = btn
      switch (btn.actionType) {
        case "DIRECT": {
          await this.customBtnRequest(
            this.sheetDef.appId,
            this.dataId,
            btn.id,
            this.sheetDef.sheetId
          )
          this.refreshData()
          console.log("click")
          this.dispatch("DetailDialog", "refresh")
          break
        }
        case "CONFIRM": {
          await this.$confirm(btn.confirmMsg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          await this.customBtnRequest(
            this.sheetDef.appId,
            this.dataId,
            btn.id,
            this.sheetDef.sheetId
          )
          this.refreshData()
          this.dispatch("DetailDialog", "refresh")
          break
        }
        case "FILL": {
          await this.fill(btn, row.id, this.sheetDef.appId)
          break
        }
      }
    },
    onColumnResize() {
      this.updateColWidth()
      setFrontSetting(this.realColWidth, this.settingId, "columnWidth").then(() => {
        this.columnWidth = this._.cloneDeep(this.realColWidth)
      })
    },
    transFields(controls) {
      return (controls || [])
        .filter(field => field._type !== "remark" && this.fields.includes(field._cid))
        .map(field => transFieldControl(field))
        .map(field => {
          return {
            rawControl: field,
            cid: field._cid,
            label: field.name,
            value: `data.${field._cid}`,
            type: field._type,
            oneFlag: field.oneFlag,
            dataType: field._dataType,
            main: field.main && !this.showProjectColumn,
            description: field.description,
            fixed:
              (field.main && !this.showProjectColumn) || this.columnLock.includes(field._cid)
                ? "left"
                : null,
            isRef: true
          }
        })
        .sort((a, b) => {
          return (
            this.fields.findIndex(cid => cid === a.cid) -
            this.fields.findIndex(cid => cid === b.cid)
          )
        })
    },
    loadTableData(row) {
      if (!this.treeKey) return Promise.resolve([])
      return getSheetViewData({
        sheetId: this.sheetId,
        page: 1,
        size: 0x7fffffff,
        conditions: this.conditions,
        sorts: this.sorts,
        ...this.refCondSearch,
        treeKey: this.treeKey,
        rootId: row.id,
        refDataShowAsFirstField: true
      }).then(res => this.dealTableData(res.content, row))
    }
  }
}
</script>
